module.exports = __webpack_public_path__ + "static/media/actn.f9cc3bc4.svg";